import { gql } from '@apollo/client';

export const EMAIL_LOGIN = gql`
	query emailLogin($email: String, $password: String) {
		emailLogin(input: { email: $email, password: $password }) {
			first_login
		}
	}
`;
